'use strict';

var EventEmitter = require('events').EventEmitter;

var ScenePreface = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function ScenePreface ()
  {
    Phaser.Scene.call(this, { key: 'scenePreface', active: false });
  },

  init: function(params){
    var self = this;
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'scenePreface';

    this.sceneBoot.scaleMode = 'height';
    this.scaler.scaleMode = 'height';

    this.scene.bringToTop();

    this.currentIndex = 0;

    for(var key in EventEmitter.prototype){
      this.__proto__[key] = EventEmitter.prototype[key];
    }

    this.scrollerBounds = {
      top: 287,
      bottom: 1024,
    };
    this.dragSprites = [];
    
    this.allowDown = true;
    this.allowUp = true;

    // this.on('dragstart-preface', function () {
    //   this.dragSprites.map(sprite => {
    //     sprite.keepData.x = sprite.x;
    //     sprite.keepData.y = sprite.y;
    //   });

    //   if(this.autoScrollerTimer) {
    //     this.autoScrollerTimer.destroy();
    //   }
    //   if(this.reScrollerTimer) {
    //     this.reScrollerTimer.destroy();
    //   }

    //   // this.contentPrefaceSprite.keepData.tilePositionY = this.contentPrefaceSprite.tilePositionY;
    // });
  
    // this.on('drag-preface', function(evt) {
    //   if(evt.offset < 0 && this.allowUp == false)
    //     return;
    //   if(evt.offset > 0 && this.allowDown == false)
    //     return;

    //   let v = 2;
    //   // this.contentPrefaceSprite.tilePositionY = this.contentPrefaceSprite.keepData.tilePositionY + evt.offset * v;
    //   this.dragSprites.map(sprite => {
    //     sprite.y = sprite.keepData.y + evt.offset * v;
    //   });
    // });
  
    // this.on('dragend-preface', function(evt) {
    //   this.dragSprites.map(sprite => {
    //     sprite.alpha = sprite.keepData.alpha;
    //   });

    //   if(this.reScrollerTimer) {
    //     this.reScrollerTimer.destroy();
    //   }
    //   this.reScrollerTimer = this.time.delayedCall(3000, function(){
    //     self.lastAllowUp = false;
    //   }, this);
    // }, this);
  
    // this.on('wheel-preface', function(evt) {
    //   if(evt.offset < 0 && this.allowUp == false)
    //     return;
    //   if(evt.offset > 0 && this.allowDown == false)
    //     return;
    //   let v = 2;
    //   this.dragSprites.map(sprite => {
    //     sprite.keepData.y = sprite.y;
    //     sprite.y = sprite.keepData.y - evt.offset * v;
    //   });
    // });

    this.playEnterAnimation = false;
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    designX = -683 + 1595;
    designY = 609.5;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'bg_preface'
    );
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY
    };
    this.bgPrefaceSprite = sprite;

    sprite.setInteractive({ draggable: true });

    // sprite.on('dragstart', function (pointer, dragX, dragY) {
    //   // console.log(`drag start.. ${pointer.x} ${pointer.y}`);
    //   this.bgPrefaceSprite.keepData.x = this.bgPrefaceSprite.x;
    //   this.bgPrefaceSprite.keepData.y = this.bgPrefaceSprite.y;
    //   this.emit('dragstart-preface');
    // }, this);
  
    // sprite.on('drag', function (pointer, dragX, dragY) {
    //   // console.log(dragX, this.bgPrefaceSprite.keepData.x);
    //   // check whether out area
    //   // console.log(this.bgPrefaceSprite.keepData.x - dragX);
    //   if(self.scaler.getDirection() == 'Horizontal'){
    //     this.emit('drag-preface', {offset: dragY - this.bgPrefaceSprite.keepData.y});
    //   } else{
    //     this.emit('drag-preface', {offset: (this.bgPrefaceSprite.keepData.x - dragX)});
    //   }
  
    // }, this);
  
    // sprite.on('dragend', function (pointer, dragX, dragY) {
    //   // console.log('drag end');
    //   this.emit('dragend-preface');
    // }, this);
  
    // sprite.on('wheel', function (pointer, deltaX, deltaY, deltaZ) {
    //   this.emit('wheel-preface', {offset: deltaY * 0.4});
    // }, this);

    designX = 0;
    designY = 0;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
      'preface'
    );
    sprite.setOrigin(1, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      ylocation: 'center',
      designX: designX,
      designY: designY
    };
    this.prefaceSprite = sprite;

    // designX = -926;
    // designY = 173.5;
    // var sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'title_preface'
    // );
    // sprite.setOrigin(0.5, 0.5);
    // this.scaler.scaleSprite(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY
    // };
    // this.titlePrefaceSprite = sprite;

    // designX = -1200;
    // designY = 286.5;
    // var sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'content_preface'
    // );
    // sprite.setOrigin(0, 0);
    // this.scaler.scaleSprite(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY
    // };
    // this.contentPrefaceSprite = sprite;
    // this.dragSprites.push(sprite);

    // designX = -1200;
    // designY = 286.5;
    // var sprite = this.add.tileSprite(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   941,
    //   700,
    //   'content_preface'
    // );
    // sprite.setOrigin(0, 0);
    // this.scaler.scaleSprite(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY
    // };
    // this.contentPrefaceSprite = sprite;
    // this.dragSprites.push(sprite);
    // window.contentPrefaceSprite = sprite;

    // designX = -1239;
    // designY = 115;
    // sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'btn_lan_cn');
    // sprite.setOrigin(0.5, 0.5);
    // this.scaler.scaleSpriteByHeight(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY
    // };
    // this.btnLanSprite = sprite;

    // sprite.setInteractive();

    // sprite.on("pointerdown", pointer => {
    //   this.btnLanSprite.setAlpha(0.5);
    // });

    // sprite.on("pointerup", pointer => {
    //   this.btnLanSprite.setAlpha(1.0);

    //   this.changeLanguage();
    // });
 
    designX = 0;
    designY = 0;
    sprite = this.add.rectangle(
      this.scaler.scaleBgX(designX),
      this.scaler.scaleY(designY),
      930,
      1080,
      0xff0000,
      0);
    sprite.setOrigin(0, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = { 
      resized: true,
      designX: designX,
      designY: designY,
    };
    sprite.setInteractive();
    var btnBackSprite = sprite;

    sprite.on("pointerdown", pointer => {
      btnBackSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      if(btnBackSprite.isPressed) {
        this.back();
      }
      btnBackSprite.isPressed = false;
    });

    // designX = -1434;
    // designY = 606;
    // sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'btn_left');
    // sprite.setOrigin(0.5, 0.5);
    // this.scaler.scaleSpriteByHeight(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY,
    //   enableClick: true,
    //   alpha: 1,
    // };
    // this.btnLeftSprite = sprite;

    // sprite.setInteractive();

    // sprite.on("pointerdown", pointer => {
    //   this.btnLeftSprite.setAlpha(0.5);
    // });

    // sprite.on("pointerup", pointer => {
    //   this.btnLeftSprite.setAlpha(1.0);

    //   this.back();
    // });

    designX = -128;
    designY = 606;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_right');
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    this.btnNextSprite = sprite;

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      this.btnNextSprite.setAlpha(0.5);
      this.btnNextSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      this.btnNextSprite.setAlpha(1.0);

      if(this.btnNextSprite.isPressed) {
        this.next();
      }

      this.btnNextSprite.isPressed = false;
    });

    this.input.on('pointerup', function () {
      utils.updateButtonsAlpha(this);
    }, this);
    
    this.sceneBoot.windowResized = true;

    utils.disableAllButtons(this);

    
  },

  update: function(){
    // this.checkEnding();
    // this.updateScrollerArea();
  },

  resized: function () {
    var self = this;

    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else{
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else{
            this.scaler.scaleSprite(s);
          }

          if(s.keepData.width){
            s.displayWidth = s.keepData.width * this.scaler.vScale();
          }
          if(s.keepData.height){
            s.displayHeight = s.keepData.height * this.scaler.vScale();
          }
        }
      }
    }

    if(this.playEnterAnimation == false) {
      this.playEnterAnimation = true;
      this.enterAnimation(function() {
        utils.enableAllButtons(self);
  
        // self.autoScroller();
        // self.reScrollerTimer = self.time.delayedCall(5000, function(){
        //   self.lastAllowUp = false;
        // }, this);
      });
    }
  },

  changeLanguage: function() {
    if(this.titlePrefaceSprite.texture.key === 'title_preface_cn') {
      this.btnLanSprite.setTexture('btn_lan_en');
      this.titlePrefaceSprite.setTexture('title_preface_en');
      this.contentPrefaceSprite.setTexture('content_preface_en');
    } else {
      this.btnLanSprite.setTexture('btn_lan_cn');
      this.titlePrefaceSprite.setTexture('title_preface_cn');
      this.contentPrefaceSprite.setTexture('content_preface_cn');
    }
  },

  back: function() {
    utils.disableAllButtons(this);

    this.backAnimation();
    this.scene.get('sceneTitle').outAnimation();
    this.scene.launch('sceneEnter');
  },

  next: function(){
    var self = this;
    utils.disableAllButtons(this);

    this.outAnimation(function() {
      self.scene.get('sceneAnimation').show();
    });

    this.scene.launch('sceneArea', {noAnimation: false});
  },

  changeTab: function(index, tabIndex) {
    this.prefaceContentGroups[index].contentSprite.setTexture('preface_content_' + index + '_' + tabIndex);
    this.prefaceContentGroups[index].tabSprites.forEach((sprite, i) => {
      if(tabIndex == i) {
        sprite.alpha = 0;
        sprite.disableInteractive();
      } else {
        sprite.alpha = 1;
        sprite.setInteractive();
      }
    });
    this.prefaceContentGroups[index].currentTabIndex = tabIndex;
  },

  checkEnding: function () {
    var self = this;
    var minY, maxY;
    var sprites = this.dragSprites;
    if(sprites.length <= 0)
      return;
    minY = sprites[0].y;
    maxY = sprites[sprites.length - 1].y + sprites[sprites.length - 1].displayHeight;

    var top = this.scaler.scaleY(this.scrollerBounds.top);
    var bottom = this.scaler.scaleY(this.scrollerBounds.bottom);
  
    if(minY >= top && maxY < bottom){
      this.allowDown = false;
      this.allowUp = false;
      return;
    }
  
    if(minY >= top){
      this.allowDown = false;
  
      var offset = minY - top;
      sprites.map(sprite => {
        sprite.y -= offset; 
      });
  
    } else{
      this.allowDown = true;
    }
  
    if(maxY <= bottom){
      this.allowUp = false;
  
      if(minY < top){
        var offset = bottom - maxY;
        sprites.map(sprite => {
          sprite.y += offset; 
        });
      }
  
    } else{
      this.allowUp = true;
    }

    if(this.lastAllowUp && this.allowUp == false) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      if(this.autoScrollerTimer) {
        this.autoScrollerTimer.destroy();
      }
      this.restartScrollerTimer = this.time.delayedCall(3000, function(){
        self.restartScrollerAnimation();
      }, this);
    }

    if(this.lastAllowUp == false && this.allowUp == true) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      this.autoScroller();
    }

    // console.log(this.allowUp);

    this.lastAllowUp = this.allowUp;
  },  

  updateScrollerArea: function(){
    var top = this.scrollerBounds.top;
    var bottom = this.scrollerBounds.bottom;

    var offset = this.scaler.offsetPos().y;
    if(this.scaler.getDirection() != 'Horizontal') {
      offset = this.scaler.offsetPos().x;
    }
    this.dragSprites.map(sprite => {
      var y0 = (sprite.y - offset)/this.scaler.vScale();
      var cropX = 0;
      var cropWidth = sprite.width;
      
      var cropHeight = bottom - top;
      if(cropHeight > sprite.height) {
        cropHeight = sprite.height;
      }
      
      var cropY = top - y0;
      if(cropY < 0) {
        cropY = 0;
      }
      sprite.setCrop(cropX, cropY, cropWidth, cropHeight);
    });
  },

  autoScroller: function() {
    if(this.autoScrollerTimer) {
      this.autoScrollerTimer.destroy();
    }
    this.autoScrollerTimer = this.time.addEvent({
      delay: 1000/30,
      callback: function(){
        this.dragSprites.forEach(sprite => {
          sprite.y -= this.scaler.vScale() * 0.5;
        });
        // this.contentPrefaceSprite.tilePositionY += this.scaler.vScale() * 0.5;
      },
      callbackScope: this,
      loop: true
    });

  },

  restartScrollerAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.dragSprites,
      alpha: {
        start: 1,
        to: 0,
      },
      duration: duration,
      delay: 0,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.dragSprites.forEach(sprite => {
          sprite.y = self.scaler.scaleY(sprite.keepData.designY);
        });
        self.tweens.add({
          targets: self.dragSprites,
          alpha: {
            start: 0,
            to: 1,
          },
          duration: duration,
          delay: 0,
          ease:'Linear',
          repeat: 0,
          yoyo: false,
          onComplete: function () {
            self.autoScroller();
          },
        });
      },
    });
  },

  showRightButtonAnimation: function(func) {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.btnNextSprite,
      alpha: {
        start: 0,
        to: 1
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
      },
    }); 
  },

  enterAnimation: function(func) {
    var self = this;
    var duration = GC.animationDuration;

    var startX = this.scaler.scaleBgX(-683 + 1595, 'right');
    var targetX = this.scaler.scaleBgX(-683, 'right');
    // this.scaler.scaleSprite(this.bgPrefaceSprite);
    // this.bgPrefaceSprite.keepData.resized = false;
    this.tweens.add({
      targets: this.bgPrefaceSprite,
      x: {
        start: startX,
        to: targetX,
      },
      duration: duration,
      delay: 0,
      ease:'Sine.easeInOut',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.bgPrefaceSprite.keepData.designX = -683;
        self.bgPrefaceSprite.keepData.resized = true;
        if(func) {
          func();
        }
      },
    }); 
  },

  outAnimation: function(func) {
    var self = this;
    var duration = GC.animationDuration;

    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });

    var startX = this.scaler.scaleBgX(this.bgPrefaceSprite.keepData.designX, 'right');
    var targetX = this.scaler.scaleBgX(this.bgPrefaceSprite.keepData.designX - this.bgPrefaceSprite.width/2);
    this.bgPrefaceSprite.keepData.resized = false;
    this.tweens.add({
      targets: this.bgPrefaceSprite,
      x: {
        start: startX,
        to: targetX,
      },
      duration: duration,
      delay: 0,
      ease:'Sine.easeInOut',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
        self.scene.stop();
      },
    });

    this.tweens.add({
      targets: [this.prefaceSprite],
      alpha:0,
      duration: 10,
      delay: 0,
      ease:'Sine.easeInOut',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    });
  },

  backAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;

    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });

    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 1,
        to: 0
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.scene.stop();
      },
    }); 
  },
});
export default ScenePreface;